import { render } from "./WeekendsOvertimePay.vue?vue&type=template&id=0064ba4e&scoped=true"
import script from "./WeekendsOvertimePay.vue?vue&type=script&lang=js"
export * from "./WeekendsOvertimePay.vue?vue&type=script&lang=js"

import "./WeekendsOvertimePay.vue?vue&type=style&index=0&id=0064ba4e&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0064ba4e"]])

export default __exports__